import '@/styles/global.css';

import { Toaster } from '@crehana/compass.ui/v3/toaster';
import { TooltipProvider } from '@crehana/compass.ui/v3/tooltip';
import { HanaFloatingChatLazy } from '@crehana/hana-ai/floating-chat';
import { SPALayout } from '@crehana/layouts/spa/layout-with-centralized';
import * as Sentry from '@sentry/react';
import { NuqsAdapter } from 'nuqs/adapters/react';
import { AddBaseFunctionality } from '@/shared/components/add-base-functionality';
import { Outlet, useParams } from '@/shared/modern-router';

const App = () => {
  const { slug } = useParams();

  return (
    <SPALayout sentryInstance={Sentry} organizationSlug={slug as string}>
      <div className="tw-isolate">
        <TooltipProvider>
          <NuqsAdapter>
            <Outlet />
            <HanaFloatingChatLazy />
          </NuqsAdapter>
          <AddBaseFunctionality />
          <Toaster />
        </TooltipProvider>
      </div>
    </SPALayout>
  );
};

export default App;
